import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../services/auth.service';
import { authUser } from '../../../interfaces/auth/auth.model';

@Component({
  selector: 'app-strategy404',
  standalone: true,
  imports: [ButtonModule, TranslateModule],
  templateUrl: './strategy404.component.html',
  styleUrl: './strategy404.component.scss'
})
export class Strategy404Component implements OnInit {
  user!: authUser | null;
  constructor(private router: Router, private authService: AuthService) {


  }
  ngOnInit(): void {
    this.authService.authBufferSub$.subscribe((authBuffer) => {
      if (authBuffer) {
        this.user = authBuffer;
      }
    })
  }
  navigateToCreateStrategy() {
    this.router.navigate(['createStrategy', 0])
  }

}
